import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';
import { GlobalComponent } from 'src/app/global/global.component';
import { GeneralService } from 'src/app/service/general.service';
import { GetListBO } from './vendor.model';

@Injectable()

export class vendorgridlist extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public global: GlobalComponent, public general: GeneralService) {
    super();
  }


  public execute(state: GetListBO): void {
    this.getList(state).subscribe(x => super.next(x));
  }
  getList(state?: GetListBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Vendor/GetVendorListFilter?", state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count']
          }
      ))


  }

















}